export default "__VITE_ASSET__73ff2013__"